export const PerPageFive = 5
export const PerPageThen = 10
export const PerPageTwenty = 20
export const PerPageOneHundred = 100
export const PerPageOneThousand = 1000
export const PerPageEmployees = 50
